import '../landing.css';

const Banner = () => {
    return (
        <div
            id="page-sub-header"
            style={{
                backgroundPosition: 'center center',
                backgroundImage: `url('/waves-back.jpg')`
            }}
        >
            <div className="header-banner-gradient">
                <div className="container" style={{ textAlign: 'center' }}>
                    <a href="#" style={{ display: 'block', marginBottom: '20px' }}>
                        <img
                            src="/WSWC_logo-white-v2.png"
                            style={{ height: '100px', margin: '0 auto' }}
                            alt="WATER SKI AND WAKEBOARD CANADA"
                        />
                    </a>
                    <h1>MEMBER SERVICES</h1>
                    <p>Sign up for a WSWC membership and get exclusive member benefits</p>
                    <br />
                    <br />
                    <a
                        href="/join"
                        className="btn btn-outline-light btn-lg"
                        style={{
                            border: '3px solid white',
                            padding: '.5rem 1.8rem',
                            fontSize: '2rem',
                            display: 'inline-block',
                            borderRadius: '0',
                            textTransform: 'none'
                        }}
                    >
                        Join Now
                    </a>
                </div>
            </div>
            <div
                style={{
                    height: '50px',
                    overflow: 'hidden',
                    background: 'rgba(41, 48, 66, 0.4)'
                }}
            >
                <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{ height: '100%', width: '100%' }}>
                    <path
                        d="M-0.56,4.45 C170.43,320.22 303.61,-93.25 500.56,46.88 L500.00,150.00 L0.00,150.00 Z"
                        style={{ stroke: 'none', fill: '#f7f9fc' }}
                    ></path>
                </svg>
            </div>
        </div>
    );
};

export default Banner;
